import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

import { fetchTranslations } from 'services/translation.service';

interface ITranslationState {
	language: string;
	loading: boolean;
	finishLoading: boolean;
	translations: { [key: string | number]: any };
}

const initialState: ITranslationState = {
	language: localStorage.getItem('bo_language') || 'he',
	loading: false,
	finishLoading: false,
	translations: {},
};

export const getLangAsync = createAsyncThunk(
	'translation/fetchLangAsync',
	async (lang: string) => {
		const translations = await fetchTranslations(lang);
		return translations;
	},
	{
		condition: (lang, { getState }) => {
			const { translation } = getState() as any;
			const fetchStatus = _.has(translation.translations, lang);
			if (fetchStatus) {
				return false;
			}
		},
	}
);

export const translationSlice = createSlice({
	name: 'translation',
	initialState,
	reducers: {
		toggleLang: (state, action: PayloadAction<string>) => {
			state.language = action.payload;
			localStorage.setItem('bo_language', state.language);
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getLangAsync.pending, (state) => {
				state.loading = true;
				state.finishLoading = false;
			})
			.addCase(getLangAsync.fulfilled, (state, action) => {
				state.loading = false;
				const { arg } = action.meta;
				state.translations = { ...state.translations, [arg]: action.payload };
				state.finishLoading = true;
			})
			.addCase(getLangAsync.rejected, (state) => {
				state.finishLoading = true;
			});
	},
});

export const { toggleLang } = translationSlice.actions;
export const selectedLanguage = (state: any) => state.translation.language;
const selectA = (state) => state.translation;
export const selectTranslations = createSelector([selectA], (state: any) => {
	const translation = state.translations[state.language] || {};
	return function (keyString?: string, fallback?: boolean) {
		const key = _.isString(keyString) ? keyString : '';
		const value = _.isString(key) ? key.split('.') : '';
		return _.has(translation, key) ? translation[key].value : fallback ? fallback : key;
	};
});

export const getLoadingLanguage = (state: any) => state.translation.loading;
export const finishLoadingLanguage = (state: any) => state.translation.finishLoading;
export const getDir = (state: any) => (_.includes(state.translation.language, 'he') ? 'rtl' : 'ltr');

export default translationSlice.reducer;
